import React, { useEffect, useState } from "react";
import { useLoader } from "../context/LoaderContext";
import { IFaqsData, IHeaderFooterData } from "../exports/interfaces";
import { dynamicFailed } from "../hooks/useToast";
import { fetchFaqs, fetchHeaderFooter } from "../api/FaqsApi";
import FaqsDetails from "../components/faqs/FaqsDetails";

const Faqs = () => {
  const { setLoading } = useLoader();
  const [headerFooterData, setHeaderFooterData] = useState<IHeaderFooterData[]>(
    []
  );
  const [faqsData, setFaqsData] = useState<IFaqsData[]>([]);
  useEffect(() => {
    Promise.all([fetchHeaderFooter(), fetchFaqs()])
      .then(([headerFooterData, faqsData]) => {
        setHeaderFooterData(headerFooterData);
        setFaqsData(faqsData);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        dynamicFailed(error.response.data.error.message);
      });
  }, [setLoading]);
  return (
    <body
      data-rsssl="1"
      className="home page-template-default page page-id-662 tg_menu_transparent tg_lightbox_black centeralign2 loftloader-lite-enabled elementor-default elementor-kit-2567 elementor-page elementor-page-662"
    >
      <FaqsDetails
        headerFooterData={headerFooterData}
        termsConditionsData={faqsData}
      />
    </body>
  );
};

export default Faqs;
